module.exports = {
  INBOUND: 'I',
  OUTBOUND: 'O',
};
